import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    collapse: {
      backgroundColor: theme.palette.colors.teal,
      margin: theme.spacing(1),
      borderRadius: 2.5,
      paddingBottom: theme.spacing(1.8),
    },
    collapseList: {
      marginLeft: theme.spacing(8),
      borderLeft: `1.5px solid ${theme.palette.colors.green}`,
    },
    reportCollapseList: {
      marginLeft: theme.spacing(8),
      borderLeft: `1.5px solid ${theme.palette.colors.green}`,

      marginTop: 12,
      marginBottom: 12,
      '& div:first-child': {
        paddingTop: 0,
        paddingBottom: 0,
        '& div': {
          marginTop: 0,
          marginBottom: 0,
        },
      },
      '& div:last-child': {
        paddingTop: 0,
        paddingBottom: 0,
        '& div': {
          marginBottom: 0,
        },
      },
      '& div + div': {
        '& div': {
          paddingLeft: 8,
        },
      },
    },
    withoutBorder: {
      marginLeft: theme.spacing(8),
    },
    nested: {
      backgroundColor: 'transparent !important',
      color: theme.palette.colors.white,
    },
    selected: {
      '&::before': {
        content: `''`,
        minWidth: 9,
        minHeight: 9,
        borderRadius: '50%',
        marginLeft: -21,
        marginRight: 12,
        backgroundColor: theme.palette.colors.white,
        border: `2px solid ${theme.palette.colors.green}`,
      },
      '& div': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    selectedTitle: {
      '&::before': {
        content: `''`,
        width: 12,
        height: 12,
        borderRadius: '50%',
        marginLeft: -22,
        marginRight: 8,
        backgroundColor: theme.palette.colors.white,
        border: `2px solid ${theme.palette.colors.green}`,
      },
    },
    resetPaddingItem: {
      paddingLeft: theme.spacing(1),
    },
    notSelected: {
      opacity: 0.6,
      '& div': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    primaryItem: {
      color: theme.palette.colors.white,
      fontWeight: 400,
      marginLeft: theme.spacing(4),
      marginTop: 2,
    },
    secondaryItem: {
      color: theme.palette.colors.white,
      fontSize: 14,
    },
    expand: {
      fill: theme.palette.colors.white,
    },
    primaryScope: {
      display: 'flex',
    },
  }),
);

export default useStyles;
